var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 -0.5C32.7917 -0.5 36.4809 0.241065 39.9091 1.6626C40.1642 1.76837 40.2852 2.0609 40.1795 2.31598C40.0737 2.57106 39.7812 2.6921 39.5261 2.58633C36.2188 1.21493 32.6597 0.5 29 0.5C13.8122 0.5 1.5 12.8122 1.5 28C1.5 43.1878 13.8122 55.5 29 55.5C44.1878 55.5 56.5 43.1878 56.5 28C56.5 24.3403 55.7851 20.7812 54.4137 17.4739C53.0303 14.1379 50.9981 11.1073 48.4454 8.55456C48.2502 8.3593 48.2502 8.04272 48.4454 7.84746C48.6407 7.65219 48.9573 7.65219 49.1525 7.84746C51.7977 10.4926 53.9036 13.6332 55.3374 17.0909C56.7589 20.5191 57.5 24.2083 57.5 28C57.5 43.7401 44.7401 56.5 29 56.5C13.2599 56.5 0.5 43.7401 0.5 28C0.5 12.2599 13.2599 -0.5 29 -0.5Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4087 34.7735C40.4087 37.2296 39.1201 38.5208 36.7979 38.5208H21.1934C18.7012 38.5208 17.4126 37.2436 17.4126 34.7735V20.8229C17.4126 18.3527 18.7012 17.0896 21.1934 17.0896H23.7563C23.7988 14.5914 25.8804 12.3037 28.9106 12.3037C31.9268 12.3037 34.0083 14.6054 34.0649 17.0896H36.6138C39.106 17.0896 40.4087 18.3808 40.4087 20.8229V34.7735ZM25.1157 17.0896H32.6914C32.6489 15.2931 31.1904 13.609 28.9106 13.609C26.6167 13.609 25.1582 15.2931 25.1157 17.0896Z",
    fill: "#303030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7695 37.1594H21.2358C19.6357 37.1594 18.772 36.3313 18.772 34.7033V20.893C18.772 19.279 19.6357 18.4369 21.2358 18.4369H36.5713C38.1431 18.4369 39.0352 19.279 39.0352 20.893V34.7033C39.0352 36.3313 38.1431 37.1594 36.7695 37.1594Z",
    fill: "#6071e7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4521 44.3162C42.3999 44.3162 45.6592 41.0858 45.6592 37.173C45.6592 33.2529 42.3926 30.0225 38.4448 30.0225C34.4971 30.0225 31.2378 33.2529 31.2378 37.173C31.2378 41.0858 34.4971 44.3162 38.4521 44.3162Z",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4521 42.7845C35.3101 42.7845 32.7905 40.28 32.7905 37.173C32.7905 34.0587 35.3027 31.5542 38.4448 31.5542C41.5869 31.5542 44.1064 34.0587 44.1138 37.173C44.1211 40.28 41.5869 42.7845 38.4521 42.7845Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4521 38.6712C39.9902 38.6712 41.0083 39.7529 41.0083 40.2102C41.0083 40.3046 40.9424 40.3481 40.8691 40.2901C40.3931 39.9053 39.5581 39.5278 38.4521 39.5278C37.3462 39.5278 36.4893 39.9198 36.0278 40.2901C35.9546 40.3409 35.8887 40.3046 35.8887 40.2102C35.8887 39.7529 36.9067 38.6712 38.4521 38.6712Z",
    fill: "#303030"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5112 36.5486C36.9067 36.5486 37.2437 36.2074 37.2437 35.7211C37.2437 35.2347 36.9067 34.8862 36.5112 34.8862C36.1157 34.8862 35.7935 35.2347 35.7935 35.7211C35.7935 36.2074 36.1157 36.5486 36.5112 36.5486Z",
    fill: "#303030"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4004 36.5486C40.7959 36.5486 41.1328 36.2074 41.1328 35.7211C41.1328 35.2347 40.7959 34.8862 40.4004 34.8862C40.0122 34.8862 39.6826 35.2347 39.6826 35.7211C39.6826 36.2074 40.0122 36.5486 40.4004 36.5486Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActing);
export default __webpack_public_path__ + "static/media/acting.82a18484228d959085d90a5122b8756c.svg";
export { ForwardRef as ReactComponent };